module.exports = __webpack_public_path__ + "static/media/php-programming-language-svgrepo-com.522f942b.svg";